export const HomePageSection = (json: IHomePageSection): IHomePageSectionModel => {
	const fromJSON = (json: IHomePageSection) => {
		const { created_at, updated_at, files, ...rest } = json

		return {
			createdAt: created_at,
			updatedAt: updated_at,
			files: files ? files.map((file) => FileModel(file)) : [],
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const homePageSectionToJSON = (obj: Partial<IHomePageSectionModel>): Partial<IHomePageSection> => {
	const { files, ...rest } = obj

	return {
		...rest,
		files: files ? [] : [],
	}
}
